module.exports = __webpack_public_path__ + "media/images/common/services/say/ogp-6ce6dfd691126d681f5bbff9a3427c1d.png";